import React from 'react';
import CanUseFeature from '@dashboard/components/CanUseFeature';
import SettingsDescription from '@dashboard/components/SettingsDescription';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import Features from '@dashboard/enums/features';
import useSellerQueries from '@dashboard/hooks/queries/useSellerQueries';
import Link from '@dashboard/components/Link/Link';
import SettingsContainer from '@/dashboard/components/SettingsContainer';
import PageHeader from '@dashboard/components/PageHeader';

const SettingsCartAbandonment = () => {
  const { seller } = useAuth();
  const { updateSeller } = useSellerQueries();

  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Cart abandonment"
        description={
          <>
            Recover lost sales by saving order details and sending a email reminder sequence when a
            checkout is abandoned.{' '}
            <Link href="/docs/articles/cart-abandonment" color="default" blank>
              Learn more
            </Link>
          </>
        }
      />

      <div className="mb-32">
        <SettingsContainer size="lg">
          <SettingsDescription className="mb-4">
            You can customize email templates and disable reminder emails in each page's After
            payment settings.
          </SettingsDescription>

          <CanUseFeature feature={Features.CART_ABANDONMENT}>
            <Form
              enableReinitialize
              initialValues={{
                checkoutAbandonment: seller.checkoutAbandonment || {
                  collectEmails: false,
                  sendEmails: false,
                },
              }}
              fields={({ values }) => [
                {
                  name: 'checkoutAbandonment.collectEmails',
                  required: false,
                  type: 'checkbox',
                  label: 'Save customer contact details',
                  tooltip:
                    "Store the customer's contact details when they leave without finishing checkout. Check local regulations before enabling.",
                },
                {
                  name: 'checkoutAbandonment.sendEmails',
                  required: false,
                  type: 'checkbox',
                  label: 'Send checkout reminder emails',
                  tooltip: 'Automatically email customers a link to complete their order.',
                  disabled: !values.checkoutAbandonment?.collectEmails,
                  inset: true,
                  className: !values.checkoutAbandonment?.collectEmails
                    ? 'opacity-50 cursor-not-allowed'
                    : '',
                },
              ]}
              onSubmit={async values => {
                try {
                  const { data } = await updateSeller(values);

                  return {
                    data,
                  };
                } catch (error) {
                  return {
                    error,
                  };
                }
              }}
            />
          </CanUseFeature>
        </SettingsContainer>
      </div>
    </div>
  );
};

export default SettingsCartAbandonment;
